import { FoundationsConstants } from '../../FoundationsConstants'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'

// create tooltip content to give to the tooltip component in visual units
export const getToolTipContent = (
    report: VisualUnitApiDTO_VisualUnit,
    isAdmin: boolean,
    sqlString: string,
    isFlashing?: boolean
) => {
    return `
    <div class="vu-tooltip-data">
        <div class="strong sub-info">Description:</div>
        <div>${report.Description && Object.keys(report.Description)?.length > 0 ? report.Description : '- none -'}</div>

        <div class="strong sub-info padding-top-medium">Measure:</div>
        <div class="measures">
            ${report.MeasureList?.length === 0 
                ? '<div class="dimension-cols">- none -</div>' 
                : `<ul>${report.MeasureList?.map((measure) => 
                    `<li>${measure.AggregateFunctionName} ${measure.MetaData?.FieldName}</li>`).join('')}
                </ul>`
            }
        </div>

        <div class="strong sub-info padding-top-medium">Filter:</div>
        <div class="filterables">
            ${report.FilterableList?.length === 0 
                ? '<div class="dimension-cols">- none -</div>' 
                : `<ul>${report?.FilterableList?.map((filter) => 
                    `<li>${filter.MetaData?.FieldName} – ${filter.FilterDisplayText}</li>`).join('')}
                </ul>`
            }
        </div>

        <div class="strong sub-info padding-top-medium">Organized By (Row):</div>
        <div class="dimension-rows">
            ${report.XAxisList?.length === 0 
                ? '<div class="dimension-cols">- none -</div>' 
                : `<ul>${report.XAxisList?.map((axis) => 
                    `<li>${axis.MetaData?.FieldName} (binned by ${axis.MetaDataBin?.BinFieldName})</li>`).join('')}
                </ul>`
            }
        </div>

        <div class="strong sub-info padding-top-medium">Organized By (Column):</div>
        <div class="dimension-cols">
            ${report.YAxisList?.length === 0 
                ? '<div class="dimension-cols">- none -</div>' 
                : `<ul>${report.YAxisList?.map((axis) => 
                    `<li>${axis.MetaData?.FieldName} (binned by ${axis.MetaDataBin?.BinFieldName})</li>`).join('')}
                </ul>`
            }
        </div>

        <div class="padding-top-medium"></div>
        <span class="strong sub-info">Auto Refresh:</span> 
        <span>${report.RefreshInterval !== 0 ? `every ${report.RefreshInterval} minutes` : '- no -'}</span>

        <div class="padding-top-medium"></div>
        <span class="strong sub-info">Privacy :</span>
        <span>${FoundationsConstants.PrivacyLockText[FoundationsConstants.PrivacyLock[report.PrivacyLock]]}
            ${report.AllowDrillThru === 'Y' ? 'Drill thru allowed' : 'Drill thru not allowed'}
        </span>

        <div></div>
        <span class="strong sub-info">Last Updated By:</span> 
        ${report.UpdatedByFullName && report.LastUpdatedOnString 
            ? `<span>${report.UpdatedByFullName} on ${report.LastUpdatedOnString}</span>` 
            : report.LastUpdatedOnString 
              ? `<span>${report.LastUpdatedOnString}</span>` 
              : ''
        }

        <div class="padding-top-medium"></div>
        <span class="strong sub-info">Created By:</span>
        ${report.CreatedByFullName && report.CreatedOnString 
            ? `<span>${report.CreatedByFullName} on ${report.CreatedOnString}</span>` 
            : report.CreatedOnString 
              ? `<span>${report.CreatedOnString}</span>` 
              : ''
        }

        ${isAdmin 
            ? `<div class="padding-top-medium"></div>
                <span class="strong sub-info">SQL Query:</span>
                <span id="sql_string_info_${report.VisualUnitId}" class="sql-query${isFlashing ? ' flashBG' : ''}">${sqlString || '-none-'}</span>`
            : ''
        }
    </div>`;
};
